import { useEffect, useRef, useState } from 'react'
import { loadHomeCache, saveHomeCache } from '../../helper/homeCache'
import appUserService from '../../services/appUserService'

const useLoadHomeCache = (init = false) => {
  const initialCacheRef = useRef(loadHomeCache())
  const [homeIcons, setHomeIcons] = useState(initialCacheRef.current?.homeIcons || [])
  const [homeBanners, setHomeBanners] = useState(initialCacheRef.current?.homeBanners || [])
  const [homeCacheLoading, setHomeCacheLoading] = useState(!initialCacheRef.current)

  useEffect(() => {
    let alive = true

    if (initialCacheRef.current) {
      return () => {
        alive = false
      }
    }

    Promise.all([
      appUserService.getHomePageConfigPartner({}),
      appUserService.getStationBannersPartner({
        skip: 0,
        limit: 3
      })
    ])
      .then(([cfgRes, bannerRes]) => {
        if (!alive) return

        const utilities = (Array.isArray(cfgRes?.data?.data) && cfgRes.data.data) || (Array.isArray(cfgRes?.data) && cfgRes.data) || []
        const banners = (Array.isArray(bannerRes?.data?.data) && bannerRes.data.data) || (Array.isArray(bannerRes?.data) && bannerRes.data) || []

        setHomeIcons(utilities)
        setHomeBanners(banners)
        saveHomeCache({ homeIcons: utilities, homeBanners: banners })
      })
      .catch(() => {
        if (!alive) return
        setHomeIcons([])
        setHomeBanners([])
      })
      .finally(() => {
        if (!alive) return
        setHomeCacheLoading(false)
      })

    return () => {
      alive = false
    }
  }, [])
  return {
    homeIcons,
    homeBanners,
    homeCacheLoading
  }
}

export default useLoadHomeCache
